import { Tooltip } from '@mui/material'
import ButtonModel from './button.model'

interface Props extends ButtonModel {
    buttonProps?: { [key: string]: any };
    IsNewMessage?: boolean;
}

export default function ButtonComponent(props: Props) {
    const IconComponent = props.Icon;
    const ButtonRightIcon = props.ButtonRightIcon

    return (
        props.IconToolTip ?
            <Tooltip title={props.IconToolTip || ""} placement='bottom-start' classes={{ tooltip: 'custom-Tooltip' }}>
                <button id={props.Id} {...props.buttonProps} type={props.Type || "button"} onClick={props.OnClick} className={`p-relative ${props.ClassName || ""} ${props.Variant} d-flex`} disabled={props.Loading || props.Variant === "disabled-btn" || props.Variant === "disabled-btn-small"}>
                    <span className="m-auto d-flex align-center" style={!props.IsNewMessage ? { paddingLeft: "4px" } : {}}>
                        {
                            (props.Icon && !(props.Loading && !props.HideLoader)) &&
                            <>
                                {
                                    props.Variant === "primary-btn-small" || props.Variant === "secondary-btn-small" || props.Variant === "disabled-btn-small" || props.Variant === "channel-setup-button" || props.Variant === "channel-manage-button" ?
                                        <IconComponent className={`${!props.ButtonLabel ? "m-auto" : "mr-1 mb-0 mt-0"} my-auto w-2`} />
                                        : <IconComponent className={`${!props.ButtonLabel ? "m-auto" : "mr-1 mb-0 mt-0"} my-auto w-3`} />
                                }
                            </>
                        }
                        {props.Loading && !props.HideLoader && <span className="mr-1 loader-primary"></span>}
                        {!!props.ButtonLabel && <span><span className={"my-auto "}>
                            {props.ButtonLabel}</span>
                            {(!!props.ButtonLabel && !!ButtonRightIcon) && <ButtonRightIcon className='ml-1' />}
                        </span>
                        }
                    </span>
                </button>
            </Tooltip > :
            <button id={props.Id} {...props.buttonProps} type={props.Type || "button"} onClick={props.OnClick} className={`p-relative ${props.ClassName || ""} ${props.Variant} d-flex`} disabled={props.Loading || props.Variant === "disabled-btn" || props.Variant === "disabled-btn-small" || props.Variant === "group-chat-button-disabled"}>
                <span className="m-auto d-flex align-center">
                    {
                        (props.Icon && !(props.Loading && !props.HideLoader)) &&
                        <>
                            {
                                props.Variant === "primary-btn-small" || props.Variant === "secondary-btn-small" || props.Variant === "disabled-btn-small" || props.Variant === "channel-setup-button" || props.Variant === "channel-manage-button" ?
                                    <IconComponent className={`${!props.ButtonLabel ? "m-auto" : "mr-1 mb-0 mt-0"}  my-auto w-2`} style={{ height: "17px" }} />
                                    : <IconComponent className={`${!props.ButtonLabel ? "m-auto" : "mr-1 mb-0 mt-0"} my-auto`} style={{ width: "1rem", height: "17px" }} />
                            }
                        </>
                    }
                    {props.Loading && !props.HideLoader && <span className="my-auto mr-1 loader-primary"></span>}
                    {!!props.ButtonLabel && <span><span className={"my-auto "}>
                        {props.ButtonLabel}</span>
                        {(!!props.ButtonLabel && !!ButtonRightIcon) && <ButtonRightIcon className='ml-1' />}
                    </span>
                    }
                </span>
            </button>
    )
}